import * as React from "react";
import { Paper, PaperProps } from "@material-ui/core";
import Draggable from "react-draggable";

export const MddDraggablePaper = (props: PaperProps) => (
  <Draggable handle=".mdd-dialog--title" cancel=".mdd-dialog-content">
    <Paper {...props} />
  </Draggable>
);
